import { useEffect, useState } from 'react';
import { Timer } from 'lucide-react';
import { cn } from '@/lib/utils';

// "2ي 5س" أو "3س 12د" أو "14:08" (آخر ساعة بالثواني)
const format = (ms) => {
  const s = Math.floor(ms / 1000);
  const d = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  const m = Math.floor((s % 3600) / 60);
  if (d > 0) return `${d}ي ${h}س`;
  if (h > 0) return `${h}س ${m}د`;
  return `${String(m).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`;
};

/** شارة "ينتهي خلال ..." لمنتج خصمه ليه موعد انتهاء (sale_ends_at من الـ API). */
const SaleEndsBadge = ({ endsAt, className }) => {
  const [left, setLeft] = useState(() => new Date(endsAt).getTime() - Date.now());

  useEffect(() => {
    if (!endsAt) return undefined;
    const tick = () => setLeft(new Date(endsAt).getTime() - Date.now());
    tick();
    // آخر ساعة بنحدّث كل ثانية، قبلها كل دقيقة كفاية
    const t = setInterval(tick, left < 3.6e6 ? 1000 : 60000);
    return () => clearInterval(t);
  }, [endsAt, left < 3.6e6]);

  if (!endsAt || left <= 0) return null;
  const urgent = left < 3.6e6 * 24;

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 px-2 py-1 rounded-full text-[11px] font-cairo font-bold shadow-md tabular-nums',
        urgent ? 'bg-brand-black text-brand-gold' : 'bg-white/95 text-burgundy-600',
        className
      )}
      title="ينتهي العرض خلال"
    >
      <Timer className="w-3.5 h-3.5" />
      ينتهي خلال {format(left)}
    </span>
  );
};

export default SaleEndsBadge;
